import React, { useState } from "react";
import { uniq } from "lodash/fp";
import { TextField } from "@material-ui/core";
import { sendCheckUser } from "../../store/userStore/userRequests";
import { useTypedDispatch } from "../../app/state";
import Multiselect, { MultiselectItem } from "../Multiselect";
import SearchUserDialog from "../../containers/DevicesPage/DeviceOwnership/SearchUserDialog";

type UserSelectionInputProps = {
  multiselect?: boolean;
  disabled?: boolean;
  required?: boolean;
  label?: string;
  name: string;
  error?: string;
  fullWidth?: boolean;
  value?: number | string;
  items?: MultiselectItem[];
  selectedItems?: MultiselectItem[];
  onSingleChange?: (value: number) => void;
  onMultiChange?: (values: number[]) => void;
}

const UserSelectionInput = (props: UserSelectionInputProps) => {
  const {
    multiselect = false,
    disabled = false,
    required = false,
    label = '',
    name,
    error = '',
    fullWidth = false,
    value = '',
    items = [],
    selectedItems = [],
    onSingleChange = () => {},
    onMultiChange = () => {},
  } = props;
  const [ isOpen, setOpen ] = useState(false);
  const dispatch = useTypedDispatch();

  const onTextFieldClick = () => {
    if (disabled) {
      return;
    }
    setOpen(true);
  }

  const onAddUser = async (user) => {
    const action = await dispatch(sendCheckUser(user.email));
    const userId = action.payload;

    if (!userId || typeof userId !== 'number' || !isFinite(userId)) {
      return;
    }

    if (multiselect) {
      const idList = [...selectedItems.map((item) => parseInt(item.id + ''))];
      idList.push(userId);

      onMultiChange(uniq(idList));

      return;
    }

    onSingleChange(userId);
  }

  return (
    <>
      {
        multiselect ? (
          <Multiselect
            disabled={disabled}
            title={label}
            name={name}
            fullWidth={fullWidth}
            onClick={onTextFieldClick}
            items={items}
            selectedItems={selectedItems}
            onChange={onMultiChange}
          />
        ) : null
      }
      {
        !multiselect ? (
          <TextField
            variant='outlined'
            name={name}
            label={label}
            fullWidth={fullWidth}
            required={required}
            disabled={disabled}
            value={value}
            onClick={onTextFieldClick}
            onChange={() => {}}
            error={Boolean(error)}
            helperText={error}
          />
        ) : null
      }
      <SearchUserDialog
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onChoose={onAddUser}
      />
    </>
  )
}

export default UserSelectionInput;